import React from "react";
import Mostsiling from "./Mostsiling";
import Banner from "./Banner/Banner";
import Bannar from "./Bannar";

function Home() {
  return (
    <div>
      <main>
        <Banner />
        <Mostsiling />
        <Bannar />
      </main>
    </div>
  );
}

export default Home;
